var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['section', _vm.$style.uploadProgressContainer]},[_c('div',{staticClass:"content has-text-centered"},[_c('div',{class:['has-text-weight-semibold', _vm.$style.uploadRadialProgress]},[_c('RadialProgressBar')],1),_c('p',{class:_vm.$style.uploadDetails},[_vm._v(" "+_vm._s(_vm.uploadStatus)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }